import axios from 'axios';
import AppConfig from "../AppConfig";

let URL = AppConfig.HOST_CLIENT_API()

export default {

    getApiversion() {
        return axios({
            method: 'get',
            url: URL + 'search/version',
        });
    },
}


// WEBPACK FOOTER //
// ./src/modules/ApiversionService.js